/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'goal-content.goal-about-content.description-edit-button': 'Modifier',
  'project-actions.project-content-about.edit-description-error-description':
    "Une erreur s'est produite. Veuillez réessayer dans quelques minutes.",
  'project-content.project-content-about.edit-description-error-title':
    'Impossible de modifier la description du projet',
  'project-content.project-content-about.the-measure-placeholder':
    'Décrivez ce que représente la réussite et ce que vous espérez accomplir.',
  'project-content.project-content-about.the-measure-title': "Comment savoir si c'est une réussite",
  'project-content.project-content-about.the-what-placeholder': "Décrivez ce projet et le travail qu'il implique.",
  'project-content.project-content-about.the-what-title': 'Ce que nous faisons',
  'project-content.project-content-about.the-why-placeholder':
    'Expliquez pourquoi ce projet est mis en œuvre et les raisons qui le motivent.',
  'project-content.project-content-about.the-why-title': 'Pourquoi nous le faisons',
  'project-content.project-content-update-date.edited': '(modifié)',
  'project-content.project-content-update-date.edited-tooltip': 'Modification : {date}',
  'project-content.project-content-update-date.last-edited-by': '(dernière modification par : {name})',
  'project-content.project-content-updates.add-update': 'Ajouter une mise à jour',
  'project-content.project-content-updates.archived': 'Archivés',
  'project-content.project-content-updates.at-risk': 'À risque',
  'project-content.project-content-updates.cancelled': 'Annulé',
  'project-content.project-content-updates.completed': 'Terminé(s) 🎉',
  'project-content.project-content-updates.date-changed': 'Date modifiée',
  'project-content.project-content-updates.edit-update': 'Modifier',
  "project-content.project-content-updates.for-date'": 'pour le {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Dernière mise à jour',
  'project-content.project-content-updates.missed-update-message': "Aucune mise à jour n'a été publiée",
  'project-content.project-content-updates.new-due-date': "Nouvelle date d'échéance",
  'project-content.project-content-updates.new-state': 'Nouvel état',
  'project-content.project-content-updates.no-updates-description': 'Ce projet ne contient pas encore de mise à jour.',
  'project-content.project-content-updates.off-track': 'Compromis',
  'project-content.project-content-updates.old-due-date': "Ancienne date d'échéance",
  'project-content.project-content-updates.old-state': 'Ancien état',
  'project-content.project-content-updates.on-track': 'Sur la bonne voie',
  'project-content.project-content-updates.paused': 'Interrompu(s)',
  'project-content.project-content-updates.pending': 'En attente',
  'project-content.project-content-updates.previous-updates-title': 'Mises à jour précédentes',
  'project-content.project-content-updates.share-update': 'Partager',
  'project-content.project-content-updates.status-changed': 'État changé',
  'project-content.project-content-updates.write-update-button': 'Rédiger une mise à jour',
  'project-update-composer.modal-post-button-label': 'Publier la mise à jour',
  'project-update-composer.modal-title': 'Publier votre mise à jour',
};
